import { ComponentType, useEffect, useState } from 'react'
import { Text } from 'blaze-ui/Text/Text'
import { Stars } from 'blaze-ui/icons/20'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import Styles from './AgenticStepIndicator.module.scss'

export interface AgenticStepIndicatorProps {
  label: string
  color?: string
  icon?: ComponentType<{ size?: number; color?: string }> | null
  startedAt?: string | null
}

const formatElapsed = (seconds: number): string => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

const computeElapsed = (startedAt?: string | null): number => {
  if (!startedAt) return 0
  return Math.max(0, Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000))
}

export const AgenticStepIndicator = ({
  label,
  color = 'var(--dark-40)',
  icon: Icon,
  startedAt,
}: AgenticStepIndicatorProps) => {
  const [elapsed, setElapsed] = useState(() => computeElapsed(startedAt))

  useEffect(() => {
    setElapsed(computeElapsed(startedAt))
    const interval = setInterval(() => {
      setElapsed(computeElapsed(startedAt))
    }, 1000)
    return () => clearInterval(interval)
  }, [startedAt])

  return (
    <div className={Styles.stepIndicator} data-testid="agentic-step-indicator">
      <div className={Styles.left}>
        {Icon ? <Icon size={14} color={color} /> : <Stars size={14} color={color} />}
        <Text variant="metadata" color={color} className={Styles.label}>
          {label}
          <LoadingEllipses />
        </Text>
      </div>
      <Text variant="metadata" color={color} className={Styles.timer}>
        {formatElapsed(elapsed)}
      </Text>
    </div>
  )
}
